/**
 * Helper Utility
 *
 * @class
 */
export default class HelperUtility {

  /**
   *  Checks if the element has one of the classes
   *
   *  @param { Object } element
   *  @param { Array } classNames
   *  @return { int }
   */
  static hasOneOfClasses(element, classNames) {
    let classes = element.className.split(' ');

    return classNames.findIndex((className) => {
      return classes.indexOf(className) > -1;
    });
  }

  /**
   * Checks if the used device is a touch device
   *
   * @return { Boolean }
   */
  static isTouchDevice() {
    return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
  }

  /**
   * Checks if the used browser supports css filters
   *
   * @return { Boolean }
   */
  static supportsCssFilter() {
    return typeof document.body.style.filter !== 'undefined' && typeof document.body.style.webkitFilter !== 'undefined';
  }
}
